/** Small pieces the digitisation queue and an upload's page share (Rx-12). */

const STATUS_BADGE: Record<string, [label: string, tone: string]> = {
  pending_review: ["Pending", "bg-amber-50 text-amber-700"],
  in_review: ["In review", "bg-sky-50 text-sky-700"],
  digitized: ["Digitised", "bg-emerald-50 text-emerald-700"],
  rejected: ["Rejected", "bg-red-50 text-red-700"],
  cancelled: ["Cancelled", "bg-gray-100 text-gray-600"],
};

export function UploadStatusBadge({ status }: { status: string }) {
  const [label, tone] = STATUS_BADGE[status] ?? [status.replace(/_/g, " "), "bg-gray-100 text-gray-500"];
  return <span className={`inline-block rounded-full px-2 py-0.5 text-xs font-medium ${tone}`}>{label}</span>;
}

/** The account's digitisations today against the daily limit. */
export function TodayCount({ used, limit }: { used: number; limit: number }) {
  const full = used >= limit;
  return (
    <span
      title={full ? "Daily digitisation limit reached for this account" : "Digitised for this account today"}
      className={`inline-block rounded-full px-2 py-0.5 text-xs tabular-nums ${full ? "bg-amber-50 font-medium text-amber-700" : "bg-gray-100 text-gray-600"}`}
    >
      {used}/{limit}
    </span>
  );
}
